import PlayArrow from '../src/PlayArrow/index.tsx';
export default PlayArrow;
